import React, { useState } from 'react';
import moment from 'moment';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import useCalendarEvents from 'pages/adminCalender/pages/organisation-calendar/hooks/useCalendarEvents';
import dayjs from 'dayjs';
import EventModal from 'pages/adminCalender/pages/organisation-calendar/components/eventModal';

import MeetingToolbar from './meetingtoolbar';
import MeetingsEventComponent from './meetingevents';
import MeetingsEventModal from './meetingeventmodal';
import MeetingsDeleteEventModal from './meetingdeletemodal';

export default function MyCalendar() {
  const allCalendarEvents = useCalendarEvents();

  const [isCalenderEventModalOpen, setIsCalenderEventModalOpen] =
    useState(false);
  // console.log('isCalenderEventModalOpen', isCalenderEventModalOpen);

  const [openDeleteEventModal, setOpenDeleteEventModal] = useState(false);
  const [title, setTitle] = useState('');
  const [openEventModal, setOpenEventModal] = useState(false);
  const [selectedEventId, setSelectedEventId] = useState();
  const [selectEventToDelete, setSelectEventToDelete] = useState();
  const [date, setDate] = useState(new Date());
  const [isDeleteSeries, setIsDeleteSeries] = useState(false);

  const onDrillDown = (e) => {
    setOpenEventModal(true);
    setDate(e);
  };

  const events = allCalendarEvents?.data?.data?.map((event) => {
    return {
      id: event?.id,
      start:
        event?.from_time !== null
          ? new Date(
              `${event?.for_date}T${dayjs(
                '2019-01-25' + event?.from_time
              ).format('HH:mm:ss.sss')}Z`
            )
          : new Date(event?.for_date),
      end:
        event?.to_time !== null
          ? new Date(
              `${event?.to_date}T${dayjs('2019-01-25' + event?.to_time).format(
                'HH:mm:ss.sss'
              )}Z`
            )
          : new Date(event?.to_date),
      title: event?.name,
      from_time: event?.from_time,
      to_time: event?.to_time,
      allDay: event?.is_holiday || event?.all_day_event,
      dateClicked: event.dayjs,
      type: event?.type,
      location: event?.location,
      created_by_id: event?.created_by_id,
      is_recurring: event?.is_recurring,
      created_by_name: event?.created_by_name,
      created_by_profile_pic: event?.created_by_profile_pic,
      dateSelected: dayjs(
        dayjs(event?.from_datetime).add(0, 'day')?.$d
      )?.format('YYYY-MM-DDTHH:mm:ss'),
    };
  });

  const localizer = momentLocalizer(moment);

  return (
    <div className='mt-10'>
      <Calendar
        localizer={localizer}
        events={events}
        onDrillDown={onDrillDown}
        startAccessor='start'
        endAccessor='end'
        components={{
          eventWrapper: (props) => (
            <MeetingsEventComponent
              {...props}
              setSelectedEventId={setSelectedEventId}
              setSelectEventToDelete={setSelectEventToDelete}
              setIsCalenderEventModalOpen={setIsCalenderEventModalOpen}
              setOpenDeleteEventModal={setOpenDeleteEventModal}
              isCalenderEventModalOpen={isCalenderEventModalOpen}
              openModal={openEventModal}
              setIsDeleteSeries={setIsDeleteSeries}
              setOpenModal={setOpenEventModal}
              title={title}
              setTitle={setTitle}
            />
          ),
          toolbar: MeetingToolbar,
        }}
        style={{ height: '900px' }}
        views={['month', 'week', 'work_week', 'day']}
        className='3xl:text-inherit'
      />
      <MeetingsEventModal
        date={date}
        openModal={openEventModal}
        setOpenModal={setOpenEventModal}
        selectedEvent={selectedEventId}
        modalTitle={title ? title : 'Schedule a meet'}
      />
      {/* <MeetingsEventModal
        openModal={isCalenderEventModalOpen}
        setOpenModal={setIsCalenderEventModalOpen}
        selectedEvent={selectedEventId}
        modalTitle={'Schedule a meeting'}
      /> */}
      <EventModal
        openModal={isCalenderEventModalOpen}
        setOpenModal={setIsCalenderEventModalOpen}
        selectedEvent={selectedEventId}
        modalTitle={'Edit event'}
      />
      <MeetingsDeleteEventModal
        openModal={openDeleteEventModal}
        setOpenModal={setOpenDeleteEventModal}
        selectEventToDelete={selectEventToDelete}
        title={title}
        isDeleteSeries={isDeleteSeries}
      />
      <div className='flex justify-end gap-x-4 mr-8 mt-4'>
        {
          // <div>
          //   <div className='bg-primary swatchBox'></div>
          //   <label className='text-sm 3xl:!text-xl'>General</label>
          // </div>
          // <div>
          //   <div className='bg-Blue swatchBox'></div>
          //   <label className='text-sm 3xl:!text-xl'>Optional</label>
          // </div>
          // <div>
          //   <div className='bg-Green swatchBox'></div>
          //   <label className='text-sm 3xl:!text-xl'>Others</label>
          // </div>
        }
        <div>
          <div className='bg-E92C2C swatchBox'></div>
          <label className='text-sm 3xl:!text-xl'>Meeting</label>
        </div>

        <div>
          <div className='bg-FF9F2D swatchBox'></div>
          <label className='text-sm 3xl:!text-xl'>Event</label>
        </div>
      </div>
    </div>
  );
}
